import { Box, Button, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface PreviousFailureScreenProps {
  onContinue: () => void;
}

// Pantalla informativa mostrada cuando el usuario reabre el widget tras un intento
// anterior que terminó en rejected o error. Permite reiniciar sin iniciar directamente
// desde cero sin aviso, mejorando la transparencia del proceso.
export function PreviousFailureScreen({ onContinue }: PreviousFailureScreenProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 6,
        gap: 2,
        textAlign: 'center',
      }}
    >
      <WarningAmberIcon sx={{ fontSize: 72, color: 'warning.main' }} />

      <Typography variant="h5" fontWeight={700}>
        Tu verificación anterior no se completó
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 400 }}>
        Hubo un problema en tu último intento de verificación. Puedes intentarlo nuevamente.
      </Typography>

      <Button variant="contained" color="primary" onClick={onContinue} sx={{ mt: 2 }}>
        Intentar de nuevo
      </Button>
    </Box>
  );
}
